module.exports = __webpack_public_path__ + "img/interactive-hero-slider-hyundai.0fe9533f.png";